// AdminDash.js
import { useEffect, useState } from "react";
import axios from "axios";
import "../styles/AdminDash.css";
import {
  Line,
  Bar,
  HorizontalBar,
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line as LineChart, Bar as BarChart } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  LineElement,
  PointElement,
  Title,
  Tooltip,
  Legend,
);

// Example chart data placeholders
const ratingTrendsData = {
  labels: ["Mon", "Tue", "Wed", "Thu", "Fri"],
  datasets: [
    {
      label: "Ratings Submitted",
      data: [12, 19, 7, 15, 10],
      fill: false,
      backgroundColor: "#007bff",
      borderColor: "#007bff",
    },
  ],
};

const userGrowthData = {
  labels: ["Week 1", "Week 2", "Week 3", "Week 4"],
  datasets: [
    {
      label: "New Users",
      data: [20, 45, 28, 60],
      backgroundColor: "#28a745",
    },
  ],
};

const topRatedData = {
  labels: ["Teacher A", "Teacher B", "Teacher C"],
  datasets: [
    {
      label: "Avg Rating",
      data: [4.8, 4.6, 4.4],
      backgroundColor: "#ffc107",
    },
  ],
};

function AdminDash() {
  const [activeTab, setActiveTab] = useState("overview");
  const [stats, setStats] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchDashboardStats = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(
          "https://server.goatteachers.com/api/admin/dashboard-overview",
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          },
        );

        setStats(response.data);
      } catch (err) {
        console.error("Error fetching admin stats:", err);
        setError("Failed to load dashboard stats.");
      }
    };

    fetchDashboardStats();
  }, []);

  // Logic for User management

  const [users, setUsers] = useState([]);
  const [filterRole, setFilterRole] = useState("");
  const [sortBy, setSortBy] = useState("recent");

  const token = localStorage.getItem("token");

  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const response = await axios.get(
          "https://server.goatteachers.com/api/admin/users",
          {
            headers: { Authorization: `Bearer ${token}` },
          },
        );
        setUsers(response.data);
      } catch (error) {
        console.error("Error fetching users:", error);
      }
    };

    fetchUsers();
  }, []);

  const promoteUser = async (userId) => {
    try {
      await axios.put(
        `https://server.goatteachers.com/api/admin/promote/${userId}`,
        {},
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      alert("User promoted to admin");
      setUsers((prev) =>
        prev.map((u) => (u.user_id === userId ? { ...u, role: "admin" } : u)),
      );
    } catch (error) {
      console.error("Error promoting user:", error);
    }
  };

  const suspendUser = (userId) => {
    alert(`Suspend logic for user ${userId} goes here.`);
  };

  const filteredUsers = users
    .filter((u) => (filterRole ? u.role === filterRole : true))
    .sort((a, b) => {
      if (sortBy === "mostActive") return (b.reviews || 0) - (a.reviews || 0);
      return 0;
    });

  // Logic for teacher and institutes

  const [teacherTab, setTeacherTab] = useState("teachers");
  const [teachers, setTeachers] = useState([]);
  const [institutes, setInstitutes] = useState([]);

  const fetchTeachers = async () => {
    try {
      const response = await axios.get(
        "https://server.goatteachers.com/api/teachers",
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      setTeachers(response.data.teachers);
    } catch (err) {
      console.error("Error fetching teachers:", err);
    }
  };

  const fetchInstitutes = async () => {
    try {
      const response = await axios.get(
        "https://server.goatteachers.com/api/institutes",
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      setInstitutes(response.data.institutes);
    } catch (err) {
      console.error("Error fetching institutes:", err);
    }
  };

  const deleteTeacher = async (id) => {
    if (!window.confirm("Are you sure you want to delete this teacher?"))
      return;
    try {
      await axios.delete(`https://server.goatteachers.com/api/teachers/${id}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      fetchTeachers();
    } catch (err) {
      console.error("Error deleting teacher:", err);
    }
  };

  const deleteInstitute = async (id) => {
    if (!window.confirm("Are you sure you want to delete this institute?"))
      return;
    try {
      await axios.delete(
        `https://server.goatteachers.com/api/institutes/${id}`,
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      );
      fetchInstitutes();
    } catch (err) {
      console.error("Error deleting institute:", err);
    }
  };

  const editTeacher = (teacher) => {
    alert(
      "You can implement a modal form here to edit:\n" +
        JSON.stringify(teacher, null, 2),
    );
  };

  const editInstitute = (institute) => {
    alert(
      "You can implement a modal form here to edit:\n" +
        JSON.stringify(institute, null, 2),
    );
  };

  useEffect(() => {
    if (activeTab === "teachers") {
      fetchTeachers();
      fetchInstitutes();
    }
  }, [activeTab]);

  //START

  const renderSection = () => {
    switch (activeTab) {
      case "overview":
        return (
          <div className="section">
            <h2>Dashboard Overview</h2>
            {error && <p className="error-message">{error}</p>}
            {!stats ? (
              <p>Loading...</p>
            ) : (
              <>
                <div className="metrics-grid">
                  <div className="admin-card">
                    Total Users: {stats.totalUsers}
                  </div>
                  <div className="admin-card">
                    Total Teachers: {stats.totalTeachers}
                  </div>
                  <div className="admin-card">
                    Total Institutes: {stats.totalInstitutes}
                  </div>
                  <div className="admin-card">
                    Ratings Given: {stats.totalRatings}
                  </div>
                  <div className="admin-card">
                    Pending Reports: {stats.totalFlags}
                  </div>
                </div>
                <div className="charts">
                  <div className="chart-card">
                    <h4>Rating Trends</h4>
                    <LineChart data={ratingTrendsData} />
                  </div>
                  <div className="chart-card">
                    <h4>User Growth</h4>
                    <BarChart data={userGrowthData} />
                  </div>
                  <div className="chart-card">
                    <h4>Top-rated Teachers</h4>
                    <BarChart
                      data={topRatedData}
                      options={{ indexAxis: "y" }}
                    />
                  </div>
                </div>
              </>
            )}
          </div>
        );
      case "users":
        return (
          <div className="section">
            <h2>User Management</h2>

            <div className="filters">
              <select
                value={filterRole}
                onChange={(e) => setFilterRole(e.target.value)}
              >
                <option value="">All Roles</option>
                <option value="student">Students</option>
                <option value="admin">Admins</option>
              </select>

              <select
                value={sortBy}
                onChange={(e) => setSortBy(e.target.value)}
              >
                <option value="recent">Recent</option>
                <option value="mostActive">Most Active (future)</option>
              </select>
            </div>

            <table className="user-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Role</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {filteredUsers.map((user) => (
                  <tr key={user.user_id}>
                    <td>{user.name}</td>
                    <td>{user.email}</td>
                    <td>{user.role}</td>
                    <td>
                      {user.role === "student" && (
                        <button onClick={() => suspendUser(user.user_id)}>
                          Suspend
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );

      case "teachers":
        return (
          <div className="section">
            <h2>Teacher & Institute Management</h2>
            <div className="tabs">
              <button
                onClick={() => setTeacherTab("teachers")}
                className={teacherTab === "teachers" ? "active" : ""}
              >
                Teachers
              </button>
              <button
                onClick={() => setTeacherTab("institutes")}
                className={teacherTab === "institutes" ? "active" : ""}
              >
                Institutes
              </button>
            </div>

            {teacherTab === "teachers" ? (
              <div>
                <h4>Teacher Directory</h4>
                <button onClick={fetchTeachers}>Refresh</button>
                <table className="user-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Designation</th>
                      <th>Department</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {teachers.map((teacher) => (
                      <tr key={teacher.teacher_id}>
                        <td>{teacher.teacher_name}</td>
                        <td>{teacher.designation}</td>
                        <td>{teacher.department}</td>
                        <td>
                          <button onClick={() => editTeacher(teacher)}>
                            Edit
                          </button>
                          <button
                            onClick={() => deleteTeacher(teacher.teacher_id)}
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            ) : (
              <div>
                <h4>Institute Directory</h4>
                <button onClick={fetchInstitutes}>Refresh</button>
                <table className="user-table">
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Type</th>
                      <th>Location</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {institutes.map((institute) => (
                      <tr key={institute.institute_id}>
                        <td>{institute.institute_name}</td>
                        <td>{institute.type}</td>
                        <td>{institute.location}</td>
                        <td>
                          <button onClick={() => editInstitute(institute)}>
                            Edit
                          </button>
                          <button
                            onClick={() =>
                              deleteInstitute(institute.institute_id)
                            }
                          >
                            Delete
                          </button>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        );
      case "reviews":
        return (
          <div className="section">
            <h2>Ratings & Review Moderation</h2>
            <p>Moderate flagged reviews and handle user reports.</p>
          </div>
        );
      case "tutors":
        return (
          <div className="section">
            <h2>Tutor Network Management</h2>
            <p>Manage upcoming tutor listings and approval process.</p>
          </div>
        );
      case "reports":
        return (
          <div className="section">
            <h2>Reports & Analytics</h2>
            <p>Export insights, filter by range and category.</p>
          </div>
        );
      default:
        return <div className="section">Select a dashboard section.</div>;
    }
  };

  return (
    <div className="admin-dash">
      <aside className="sidebar">
        <h3>Goatt Admin</h3>
        <ul>
          <li onClick={() => setActiveTab("overview")}>Overview</li>
          <li onClick={() => setActiveTab("users")}>User Management</li>
          <li onClick={() => setActiveTab("teachers")}>Teacher & Institute</li>
          <li onClick={() => setActiveTab("reviews")}>Review Moderation</li>
          <li onClick={() => setActiveTab("tutors")}>Tutor Network</li>
          <li onClick={() => setActiveTab("reports")}>Reports & Analytics</li>
        </ul>
      </aside>
      <main className="content">{renderSection()}</main>
    </div>
  );
}

export default AdminDash;
